module.exports = __webpack_public_path__ + "static/img/xcx_code.7eaaf6e.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/xcx_code.jpg
// module id = JqM+
// module chunks = 1